import {FieldInput, Icon} from '@sollapay/ui/components';
import {NAME_MAX_LENGTH, hasValue} from '@sollapay/utils';
import {useTranslation} from 'react-i18next';

import {englishNameRule} from '@/lib/validation';

import type {AccountSettingsFormValues} from '../../hooks';
import type {FC} from 'react';
import type {UseFormReturn} from 'react-hook-form';

export interface AccountProfileFieldsProps {
  form: UseFormReturn<AccountSettingsFormValues>;
  email?: string;
}

export const AccountProfileFields: FC<AccountProfileFieldsProps> = ({form, email}) => {
  const {t} = useTranslation('settings');
  const {
    register,
    formState: {errors}
  } = form;

  return (
    <div data-slot="account-profile-fields" className="flex flex-col gap-5">
      <div className="grid grid-cols-2 gap-4">
        <FieldInput
          label={t('accountModal.fields.firstName.label')}
          required
          maxLength={NAME_MAX_LENGTH}
          error={errors.firstName?.message}
          {...register('firstName', requiredNameRule(t('accountModal.fields.firstName.required')))}
        />
        <FieldInput
          label={t('accountModal.fields.lastName.label')}
          required
          maxLength={NAME_MAX_LENGTH}
          error={errors.lastName?.message}
          {...register('lastName', requiredNameRule(t('accountModal.fields.lastName.required')))}
        />
        <FieldInput
          label={t('accountModal.fields.firstNameEn.label')}
          placeholder={t('accountModal.fields.firstNameEn.placeholder')}
          required
          maxLength={NAME_MAX_LENGTH}
          error={errors.firstNameEn?.message}
          {...register(
            'firstNameEn',
            englishNameRule(t, t('accountModal.fields.firstNameEn.required'))
          )}
        />
        <FieldInput
          label={t('accountModal.fields.lastNameEn.label')}
          placeholder={t('accountModal.fields.lastNameEn.placeholder')}
          required
          maxLength={NAME_MAX_LENGTH}
          error={errors.lastNameEn?.message}
          {...register(
            'lastNameEn',
            englishNameRule(t, t('accountModal.fields.lastNameEn.required'))
          )}
        />
      </div>

      <FieldInput
        label={t('accountModal.fields.email.label')}
        value={email ?? ''}
        disabled
        startAdornment={<Icon name="lock" className="size-4" />}
        description={t('accountModal.fields.email.description')}
      />
    </div>
  );
};

function requiredNameRule(message: string) {
  return {validate: (value: string) => hasValue(value) || message};
}
